import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  PasswordInput,
  required,
  email,
  minLength,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function CreateToolbar() {
  const navigate = useNavigate();
  return (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <Button onClick={() => navigate(-1)}>Annulla</Button>
    </Toolbar>
  );
}

export function UserCreate() {
  return (
    <Create redirect="list">
      <SimpleForm toolbar={<CreateToolbar />}>
        <TextInput
          source="email"
          label="Email"
          validate={[required(), email()]}
          fullWidth
        />
        <PasswordInput
          source="password"
          label="Password"
          validate={[required(), minLength(8)]}
          fullWidth
        />
        <SelectInput
          source="role"
          label="Ruolo"
          validate={[required()]}
          choices={[
            { id: "admin", name: "Amministratore" },
            { id: "viewer", name: "Utente" },
          ]}
          defaultValue="viewer"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
